import { SEGMENTS_FAMILY_NAME } from "app/components/widget/widget-utilities/segments/constants";
import { DEFAULT_DURATION_FOR_SEGMENTS, DISABLED_DURATIONS, getShouldHideSegments } from "../utils";

export const BounceRateGroup = {
    id: "SegmentsBounceRateGroup",
    properties: {
        order: "7",
        dropdownOrder: 7,
        hasWebSource: true,
        isHidden: getShouldHideSegments,
        component: "CustomSegments",
        mobileWebComponent: "MobileWebSearch",
        viewPermissions: {
            trafficSources: ["Desktop", "Total"],
        },
        title: "folderanalysis.tabs.bounce",
        group: "WebsiteAudienceOverview",
        family: SEGMENTS_FAMILY_NAME,
        dashboard: "true",
        compareOnly: "true",
        state: "digitalsuite_segments-analysis-traffic",
        apiController: "CustomSegments",
        webSource: "Desktop",
        availabilityComponent: "CustomSegments",
        periodOverPeriodSupport: true,
        defaultDuration: DEFAULT_DURATION_FOR_SEGMENTS,
        disabledDurations: DISABLED_DURATIONS,
    },
    widgets: {
        single: {
            defaultType: "SegmentsBounceRateGroupGraph",
            SegmentsBounceRateGroupGraph: {
                properties: {
                    options: {
                        showLegend: true,
                    },
                    periodOverPeriodSupport: true,
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Bounce Rate",
                    type: "long",
                    format: "percentagesign",
                    formatParameter: 0,
                    name: "BounceRate",
                    reversed: "False",
                    yAxisMax: 1,
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                },
            },
        },
        compare: {
            defaultType: "SegmentsBounceRateGroupGraph",
            SegmentsBounceRateGroupGraph: {
                properties: {},
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    title: "Bounce Rate",
                    // type: "long",
                    // format: "percentagesign",
                    // formatParameter: 0,
                    type: "double",
                    format: "percentagesign",
                    formatParameter: 3,
                    name: "BounceRate",
                    reversed: "False",
                    yAxisMax: 100,
                },
                filters: {
                    timeGranularity: [
                        {
                            value: "Daily",
                            title: "Daily",
                        },
                        {
                            value: "Weekly",
                            title: "Weekly",
                        },
                        {
                            value: "Monthly",
                            title: "Monthly",
                        },
                    ],
                },
            },
        },
    },
};
